import {HttpInterceptorFn} from '@angular/common/http';
import {environment} from "../../../environments/environment";

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('🔍 REQUEST INTERCEPTOR - Original URL:', req.url);
  console.log('🌐 Environment:', {
    apiUrl: environment.apiUrl,
    backendUrl: environment.backendUrl,
    hostName: environment.hostName
  });

  let requestUrl = '';
  if (req.url.includes('uploads')) {
    // If the URL contains 'uploads', don't prepend 'api'
    requestUrl = `${environment.backendUrl}${req.url}`;
  } else {
    // Otherwise, prepend 'api'
    requestUrl = `${environment.apiUrl}/${req.url}`;
  }

  console.log('🎯 REQUEST INTERCEPTOR - Final URL:', requestUrl);
  return next(req.clone({url: requestUrl}));
};


